<template>
    <div class="o-reset-map-view reset-map-view ">
        <button
            @click="resetMapView"
            class="reset-map-view__button"
        >
            <span class="reset-map-view__icon-wrapper">
                <svg-icon
                    original
                    name="icons/compass-shape"
                    class="reset-map-view__icon"
                />
            </span>
            {{$t('ui.center-road-directions')}}
        </button>    
    </div>
</template>

<script>
import { RESET_MAP_VIEW } from "../../../shared/components/map-viewer/constants/map-commands";

export default {
    name: 'OResetMapView',
    methods: {
        resetMapView() {
            this.$bus.$emit('RESET_MAP_VIEW')
            this.$emit('closeResetMapView')
        }
    }
}
</script>

<style lang="scss">
@import "o-reset-map-view";
</style>
